export default {
  en: {
    stopSentence: 'Stop: {{sentence}}',
    playSentence: 'Play: {{sentence}}',
  },
  ru: {
    stopSentence: 'Остановить: {{sentence}}',
    playSentence: 'Озвучить: {{sentence}}',
  },
  de: {
    stopSentence: 'Stoppen: {{sentence}}',
    playSentence: 'Abspielen: {{sentence}}',
  },
  pt: {
    stopSentence: 'Parar: {{sentence}}',
    playSentence: 'Ouvir: {{sentence}}',
  },
  fr: {
    stopSentence: 'Arrêter : {{sentence}}',
    playSentence: 'Écouter : {{sentence}}',
  },
  es: {
    stopSentence: 'Detener: {{sentence}}',
    playSentence: 'Escuchar: {{sentence}}',
  },
};
